import { Component, EventEmitter, Input, OnChanges, Output,OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  PipelineDetailsDto,
  PipelineSectionDto,
  AssetStatusDto,
  PigibilityDto,
  PipelineAssetLocationDto,
  DeliveryTypeDto,
  LicenceStatusDto,
  UomDto,
  NetworkDto, CategoryDto, SubSubGroupDto,
  IPStatusDto,FunctionDto,
  PipelineGradeDto,AccountableFunctionDto,LandTitleDto
} from '@cradua/data';
import Swal from 'sweetalert2';
import { filter } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'cradua-pipelinesection',
  templateUrl: './pipelinesection.component.html',
  styleUrls: ['./pipelinesection.component.scss'],
})
export class PipelinesectionComponent implements OnChanges, OnInit {
  pipelinesectionForm: FormGroup;
  @Input() selectedPipelineDetails: PipelineDetailsDto;
  @Input() assetstatuss: AssetStatusDto[];
  @Input() pigibilitys: PigibilityDto[];
  @Input() assetlocations: PipelineAssetLocationDto[];
  @Input() deliverytypes: DeliveryTypeDto[];
  @Input() licencestatuss: LicenceStatusDto[];
  @Input() uomes: UomDto[];
  @Input() networks: NetworkDto[];
  @Input() ipstatuss: IPStatusDto[];
  @Input() pipelinegrades: PipelineGradeDto[];
  @Input() pipelinedetails: any[];
  @Input() categorys: CategoryDto[];
  @Input() subsubgroups: SubSubGroupDto[];
  @Input() functions: FunctionDto[];
  @Input() pipelinesections: PipelineSectionDto[];
  @Input() accountablefunctions: AccountableFunctionDto[];
  @Input() pipelineassets: LandTitleDto[];
  @Output() emitSave = new EventEmitter<PipelineSectionDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Input() isLoadingPipelinesections: boolean;
 
  sectionList = [];
  filteredDelete: any[] = [];

  lengthUnitOfMeasures = [];
  diameterUnitOfMeasures = [];
  wallThicknessUnitOfMeasures = [];
  pressureUnitOfMeasures = [];


  constructor(private fb: FormBuilder) {}

  ngOnChanges(): void {
    this.createPipelineSection();
    if (
      this.pipelinesections != null &&
      this.pipelinesections.length
    ) {
      this.setPipelineSection(this.pipelinesections);
    }
    this.sectionList = this.pipelinesections;
  }

  ngOnInit(){

    console.log("Units of Measure ", this.uomes);

      for(let unit of this.uomes){

         if(unit.UomName.toLowerCase() === 'tba'){
          this.lengthUnitOfMeasures.push(unit);
          this.diameterUnitOfMeasures.push(unit);
          this.wallThicknessUnitOfMeasures.push(unit);
          this.pressureUnitOfMeasures.push(unit);
         }

         if(unit.UomName.toLowerCase() === 'km' || unit.UomName.toLowerCase() === 'm'){
          this.lengthUnitOfMeasures.push(unit);
         }

         if(unit.UomName.toLowerCase() === 'mm' || unit.UomName.toLowerCase() === 'inches'){
          this.diameterUnitOfMeasures.push(unit);
          this.wallThicknessUnitOfMeasures.push(unit);
         }

         if(unit.UomName.toLowerCase() === 'bar' || unit.UomName.toLowerCase() === 'psi'){
          this.pressureUnitOfMeasures.push(unit);
         }
      }

      this.lengthUnitOfMeasures =  this.lengthUnitOfMeasures.sort(function(a,b){
       return a.UomName.toLowerCase().localeCompare(b.UomName.toLowerCase());
       
      })

      this.diameterUnitOfMeasures =  this.diameterUnitOfMeasures.sort(function(a,b){
        return a.UomName.toLowerCase().localeCompare(b.UomName.toLowerCase());
      })

      this.wallThicknessUnitOfMeasures =  this.wallThicknessUnitOfMeasures.sort(function(a,b){
        return a.UomName.toLowerCase().localeCompare(b.UomName.toLowerCase());
      })

      this.pressureUnitOfMeasures =  this.pressureUnitOfMeasures.sort(function(a,b){
        return a.UomName.toLowerCase().localeCompare(b.UomName.toLowerCase());
      })
  }

  createPipelineSection() {
    this.pipelinesectionForm = this.fb.group({
      PipelineSectionName: ['', Validators.required],
      AssetStatusId: [''],
      NetworkId: [''],
      PigibilityId: [''],
      IpStatusId: [''],
      LicenceStatusId: [''],
      PipelineGradeId: [''],
      LengthUOMId: [''],
      LengthUOMName: [''],
      Length: [0],
      DiameterUOMId: [''],
      DiameterUOMName: [''],
      Diameter: [0],
      WallThicknessUOMId: [''],
      WallThicknessUOMName: [''],
      WallThickness: [0],
      DesignedPressureUOMId: [''],
      DesignedPressureUOMName: [''],
      DesignedPressure: [0],
      Remarks: [''],
      PipelineAssetLocationId: [''],
      DeliveryTypeId: [''],
      TerrainId: [''],
      TerrianName: [''],
      SubscriberId: ['0'],
      SubscriptionUserId: ['0'],
      createdAt: [''],
      updatedAt: [''],
      AutoSerialId: [this.selectedPipelineDetails.id],
      id: null,
    });

  }

  setPipelineSection(pipelineSections: PipelineSectionDto[]) {
    pipelineSections.forEach((value) => {

      this.pipelinesectionForm.patchValue({
        PipelineSectionName: value.PipelineSectionName,
        AssetStatusId: value.AssetStatusId,
        NetworkId: value.NetworkId,
        PigibilityId: value.PigibilityId,
        IpStatusId: value.IpStatusId,
        LicenceStatusId: value.LicenceStatusId,
        PipelineGradeId: value.PipelineGradeId,
        LengthUOMId: value.LengthUOMId,
        // LengthUOMName: value,
        Length: value.Length,
        DiameterUOMId: value.DiameterUOMId,
        // DiameterUOMName: value,
        Diameter: value.Diameter,
        WallThicknessUOMId: value.WallThicknessUOMId,
        // WallThicknessUOMName: value,
        WallThickness: value.WallThickness,
        DesignedPressureUOMId: value.DesignedPressureUOMId,
        // DesignedPressureUOMName: value,
        DesignedPressure: value.DesignedPressure,
        Remarks: value.Remarks,
        DeliveryTypeId: value.DeliveryTypeId,
        PipelineAssetLocationId: value.PipelineAssetLocationId,
        id: value.id,
      });
    });
  }

  public errorHandling = (control: string, error: string) => {
    return this.pipelinesectionForm.controls[control].hasError(error);
  };

  protected filterById = <T>(id: string, lookupId: string) => (fieldName: T) =>
    fieldName[lookupId] === id;

  getLicenceStatus(id) {
    return this.licencestatuss.find((n) => n.id === id).LicenceStatusName;
  }

  onCreate() {
    this.pipelinesectionForm.reset();
  }

  onPatchValue(value) {
    this.pipelinesectionForm.patchValue({
      PipelineSectionName: value.PipelineSectionName,
      AssetStatusId: value.AssetStatusId,
      NetworkId: value.NetworkId,
      PigibilityId: value.PigibilityId,
      IpStatusId: value.IpStatusId,
      LicenceStatusId: value.LicenceStatusId,
      PipelineGradeId: value.PipelineGradeId,
      LengthUOMId: value.LengthUOMId,
      // LengthUOMName: value,
      Length: value.Length,
      DiameterUOMId: value.DiameterUOMId,
      // DiameterUOMName: value,
      Diameter: value.Diameter,
      WallThicknessUOMId: value.WallThicknessUOMId,
      // WallThicknessUOMName: value,
      WallThickness: value.WallThickness,
      DesignedPressureUOMId: value.DesignedPressureUOMId,
      // DesignedPressureUOMName: value,
      DesignedPressure: value.DesignedPressure,
      Remarks: value.Remarks,
      DeliveryTypeId: value.DeliveryTypeId,
      PipelineAssetLocationId: value.PipelineAssetLocationId,
      id: value.id,
    });
  }

  onDelete(value, index) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        if (value.id !== null) {
          this.sectionList = this.sectionList.filter(a => a.id !== value.id);
          this.filteredDelete.push(this.pipelinesections[index].id);
          this.deleteEvent.emit(this.filteredDelete);
          this.filteredDelete = [];
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
    this.pipelinesectionForm.updateValueAndValidity();
  }

  onSubmit(formValue: PipelineSectionDto) {
    if(this.pipelinesectionForm.invalid) {
      return;
    }
    formValue.AutoSerialId = this.selectedPipelineDetails.id;
    formValue.SubscriberId = this.selectedPipelineDetails.SubscriberId;
    formValue.SubscriptionUserId = this.selectedPipelineDetails.SubscriptionUserId;
    if (this.pipelinesectionForm.valid) {
      // this.pipelinesectionForm.patchValue(formValue);
      this.emitSave.emit(formValue);
    }
  }
}
